export enum E_DeviceType {
  MOBILE = 'Mobile',
  TABLET = 'Tablet',
  DESKTOP = 'Desktop',
}

export type T_Platform = {
  name: string;
  version: string;
};

export type T_DeviceData = {
  deviceType: E_DeviceType;
  operatingSystem: T_Platform;
  browser: T_Platform;
  userAgent: string;
};
